import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import * as ReactDOM from 'react-dom';
var portalClasses = {
  MAIN: 'portal'
};
export var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);
  var _super = _createSuper(Portal);
  function Portal() {
    var _this;
    _classCallCheck(this, Portal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      hasMounted: false
    });
    _defineProperty(_assertThisInitialized(_this), "_portalElement", void 0);
    _defineProperty(_assertThisInitialized(_this), "createContainerElement", function () {
      var container = document.createElement('div');
      container.classList.add(portalClasses.MAIN);
      maybeAddClass(container.classList, _this.props.className);
      return container;
    });
    return _this;
  }
  _createClass(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.container) {
        return;
      }
      this._portalElement = this.createContainerElement();
      this.props.container.appendChild(this._portalElement);
      this.setState({
        hasMounted: true
      }, this.props.onChildrenMount);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this._portalElement != null && prevProps.className !== this.props.className) {
        maybeRemoveClass(this._portalElement.classList, prevProps.className);
        maybeAddClass(this._portalElement.classList, this.props.className);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._portalElement != null) {
        this._portalElement.remove();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (typeof document === 'undefined' || !this.state.hasMounted) {
        return null;
      } else {
        return ReactDOM.createPortal(this.props.children, this._portalElement);
      }
    }
  }]);
  return Portal;
}(React.Component);
_defineProperty(Portal, "defaultProps", {
  container: typeof document !== 'undefined' ? document.body : undefined
});
function maybeAddClass(classList, className) {
  if (className != null && className !== '') {
    classList.add.apply(classList, _toConsumableArray(className.split(' ')));
  }
}
function maybeRemoveClass(classList, className) {
  if (className != null && className !== '') {
    classList.remove.apply(classList, _toConsumableArray(className.split(' ')));
  }
}